export const SIGNS_BOLLARDS_BASE_PATH = '/signs-and-bollards';
export const RoutesList = {
  SIGNS_BOLLARDS_HOME: SIGNS_BOLLARDS_BASE_PATH,
  ISSUE_TYPE: SIGNS_BOLLARDS_BASE_PATH + '/issue',
  ISSUE_LOCATION: SIGNS_BOLLARDS_BASE_PATH + '/issue-location',
  DESCRIBE_ISSUE: SIGNS_BOLLARDS_BASE_PATH + '/describe-issue',
  REPORT_ISSUE_TO_STREETLIGHTS_TEAM:
    SIGNS_BOLLARDS_BASE_PATH + '/report-issue-to-streetlights-team',
  UPLOAD_PHOTO: SIGNS_BOLLARDS_BASE_PATH + '/upload-photo',
  LOCATION_ADDITIONAL_INFORMATION:
    SIGNS_BOLLARDS_BASE_PATH + '/location-additional-information',
  EMAIL_CONFIRMATION: SIGNS_BOLLARDS_BASE_PATH + '/email-confirmation',
  CONTACT_USER_OPTION: SIGNS_BOLLARDS_BASE_PATH + '/contact-user-option',
  CONFIRMATION: SIGNS_BOLLARDS_BASE_PATH + '/confirmation',
  YOUR_DETAILS: SIGNS_BOLLARDS_BASE_PATH + '/your-details',
  NOT_FOUND: '*',
  INTERNAL_SERVER_ERROR: '/500',
};

export const steps = [
  {
    label: 'Details ',
    urlPaths: [RoutesList.ISSUE_TYPE, RoutesList.DESCRIBE_ISSUE],
  },
  {
    label: 'Photos',
    urlPaths: [RoutesList.UPLOAD_PHOTO],
  },
  {
    label: 'Location',
    urlPaths: [
      RoutesList.ISSUE_LOCATION,
      RoutesList.LOCATION_ADDITIONAL_INFORMATION,
    ],
  },
  {
    label: 'Your details',
    urlPaths: [
      RoutesList.EMAIL_CONFIRMATION,
      RoutesList.CONTACT_USER_OPTION,
      RoutesList.YOUR_DETAILS,
    ],
  },
];
